
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/feeds/sangjo-join",
      function () {
        return require("private-next-pages/content/feeds/sangjo-join.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/feeds/sangjo-join"])
      });
    }
  